const T = "default", A = 5e3, o = "body";
export {
  o as TOAST_TARGET,
  A as TOAST_TIME_OUT,
  T as TOAST_VARIANT_DEFAULT
};
